import {createSlice, type PayloadAction} from "@reduxjs/toolkit";

import {type AppEnvironment, defaultAppEnvironment} from "../environment";

interface EnvState {
    appEnvironment: AppEnvironment;
}

const initialState: EnvState = {
    appEnvironment: defaultAppEnvironment,
};

export const envSlice = createSlice({
    name: "env",
    initialState,
    reducers: {
        initializeEnvironment: (state, action: PayloadAction<{appEnvironment: AppEnvironment}>) => {
            state.appEnvironment = action.payload.appEnvironment;
        },
    },
    selectors: {
        selectAppEnvironment: (state) => state.appEnvironment,
        selectDevelopMode: (state) => state.appEnvironment.isDevelopmentMode,
        selectAppRoleLabel: (state) => state.appEnvironment.roleLabel,
        selectEvaPlusUrl: (state) => state.appEnvironment.evaPlusUrl,
        selectRevaApiFullUrl: (state) => state.appEnvironment.revaApiFullUrl,
        selectAvmApiFullUrl: (state) => state.appEnvironment.avmApiFullUrl,
    },
});

export const {initializeEnvironment} = envSlice.actions;

export const {
    selectAppEnvironment,
    selectDevelopMode,
    selectAppRoleLabel,
    selectEvaPlusUrl,
    selectRevaApiFullUrl,
    selectAvmApiFullUrl,
} = envSlice.selectors;

export default envSlice.reducer;
